// RU-SCANPERF SP-9: the app's router navigate function, for components that must not import the router
// themselves (this jest cannot resolve react-router-dom 7's package entry, and a second copy of the router
// in the bundle would have its own context). NavBridge (inside BrowserRouter) registers it.
let navigator = null;

export function setNavigator(fn) {
  navigator = typeof fn === "function" ? fn : null;
}

// true when the app router took the navigation; false means "let the browser follow the href".
export function navigateTo(to) {
  if (!navigator) return false;
  navigator(to);
  return true;
}
